import Vue from 'vue';
import loader from 'vue-ui-preloader';
import vcharts from 'vue-apexcharts';
import vmoney from 'v-money';
import vmeta from 'vue-meta';
import VueGtm from '@gtm-support/vue2-gtm';
import PortalVue from 'portal-vue';
import FloatingVue from 'floating-vue';

import '@fortawesome/fontawesome-free/css/all.css';
import 'animate.css/animate.min.css';
import 'floating-vue/dist/style.css';

import TheError from '@/components/TheError.vue';

import { ValidationProvider, ValidationObserver } from './plugins/vee-validate';

import App from './App.vue';
import router from './router';
import store from './stores';
import { truncate, money, normalizeText } from './utils';

Vue.config.productionTip = false;

if (window.location.hostname.includes('queroprata')) Vue.config.devtools = true;

// uses
Vue.use(vcharts);
Vue.use(loader);
Vue.use(vmoney, { precision: 2 });
Vue.use(vmeta);
Vue.use(PortalVue);
Vue.use(FloatingVue);

if (
  process.env.VUE_APP_ENV === 'production'
  && !window.location.hostname.includes('queroprata')
) {
  Vue.use(VueGtm, {
    id: 'GTM-P6KPZFSJ',
    defer: false,
    compatibility: false,
    enabled: true,
    loadScript: true,
    vueRouter: router,
    trackOnNextTick: false,
  });
}

Vue.component('VChart', vcharts);
Vue.component('VValidate', ValidationProvider);
Vue.component('VValidateObserver', ValidationObserver);
Vue.component('TheError', TheError);

Vue.filter('truncate', truncate);
Vue.filter('money', money);
Vue.filter('normalizeText', normalizeText);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
